import { QASAddressLookUpObject } from '../QASAddressLookUp.types';

/**
 * Returns true if query contains 3 or more consecutive alphabetic
 * characters.
 *
 * @param query - the query to check
 */
export const isQuerySearchable = (query: string): boolean => {
  return query.match(/[\w]{3}/i) ? true : false;
};

/**
 * Returns the search query from an address object or empty string.
 *
 * @param address - the address object
 */
export const getQueryValue = (address: QASAddressLookUpObject): string => {
  if (address && address.qasSearchResult && address.qasSearchResult.label) {
    return address.qasSearchResult.label;
  } else if (address.qasAddress) {
    const qas = address.qasAddress;
    const unit = qas.unit ? `${qas.unit}, ` : '';
    const level = qas.level ? `${qas.level}  ` : '';
    return `${unit}${level}${qas.streetNumber} ${qas.streetName}, ${qas.city.toUpperCase()}  ${
      qas.state
    }  ${qas.postcode}`;
  }
  return '';
};
